export const states = [
  { value: 'true', name: 'Activo' },
  { value: 'false', name: 'Inactivo' },
];